<template>
  <v-form
  class="pa-6"
    ref="form"
    lazy-validation>

    <h3 class="text-left mb-1 text-primary">Status</h3>
    <p class="text-caption mb-4">Consultá el estado del servicio de Alison Desktop.</p>
    <div class="d-flex ga-2 mb-6">
      <v-btn
          size="small"
          color="primary"
          @click="isRunning"
          :loading="loadingRun"
          :disabled="loadingEnabled || loadingEnable">
        is Running?
      </v-btn>
      <v-btn
          size="small"
          color="primary"
          @click="isEnabled"
          :loading="loadingEnabled"
          :disabled="loadingRun || loadingEnable"
      >
        is Enabled?
      </v-btn>
      <v-btn
          size="small"
          color="primary"
          @click="enable"
          :loading="loadingEnable"
          :disabled="loadingRun || loadingEnabled"
      >
        Enable
      </v-btn>
    </div>
  </v-form>
</template>
<script>
  import alisonJS from  '@/services/alison_js.js'
  import { mapMutations } from 'vuex'
  export default {
    data: () => ({
      loadingRun: false,
      loadingEnabled: false,
      loadingEnable: false,
    }),
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),

      isEnabled(){
        this.loadingEnabled = true;
        alisonJS.isEnabled().then(responseEnabled=>{
          this.loadingEnabled = false
          if(responseEnabled){
            this.setColor('info')
            this.setSnack('Alison desktop is enabled!')
          } else {
            this.setColor('error')
            this.setSnack('Alison desktop is not enabled!')
          }
        })
      },
      isRunning(){
        this.loadingRun = true;
        alisonJS.isRunning().then(running=>{
          this.loadingRun = false
          console.log("alisonJS:", alisonJS)
          if(running){
            this.setColor('info')
            this.setSnack('Alison desktop is running! version: '+alisonJS.desktopVersion())
          } else {
            this.setColor('error')
            this.setSnack('Alison desktop is not running!')
          }
        })
      },
      enable(){
        this.loadingEneble = true;
        alisonJS.enable().then(enable=>{
            console.log("enable:", enable)
            this.loadingEnable = false
            this.setColor('info')
            this.setSnack('AlisonDesktop.enable() called!')
        })
      },
    }
  }
</script>
